export default __webpack_public_path__ + "static/media/menu.1d06cf01.svg";